/**
 * Liftcabine die meebeweegt met de verdieping in het schermmidden
 */

const CareerLift = () => {
  const lijst = document.querySelector('.js-career-lift')
  if (!lijst) return

  const etages = [].slice.call(lijst.querySelectorAll('.js-career-lift-floor'))
  const cabine = lijst.querySelector('.js-career-lift-cabin')
  const schacht = lijst.querySelector('.c-career-lift__shaft')
  if (!etages.length || !cabine || !schacht) return

  const traag = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  let hovert = false
  let wacht = false
  let deurTimer = null
  let huidige = null

  const zet = winnaar => {
    if (winnaar === huidige || !winnaar) return
    huidige = winnaar

    etages.forEach(e => e.classList.toggle('c-career-lift__floor--here', e === winnaar))

    // offsetTop binnen de lijst, niet viewport-coordinaten: die veranderen bij
    // elke scroll en zouden de cabine laten trillen.
    const doel = winnaar.offsetTop + (winnaar.offsetHeight - cabine.offsetHeight) / 2
    const max = schacht.clientHeight - cabine.offsetHeight - 6
    cabine.style.transform = `translateY(${Math.max(6, Math.min(doel, max))}px)`

    cabine.classList.remove('c-career-lift__cabin--open')
    clearTimeout(deurTimer)
    deurTimer = setTimeout(() => {
      cabine.classList.add('c-career-lift__cabin--open')
    }, traag ? 0 : 580)
  }

  // Eén IntersectionObserver per etage markeert ze in een compacte lijst alle
  // vier tegelijk. Daarom zelf de afstand tot het schermmidden uitrekenen.
  const kies = () => {
    if (hovert) return
    const lr = lijst.getBoundingClientRect()
    if (lr.bottom < 0 || lr.top > window.innerHeight) return

    const midden = window.innerHeight / 2
    let best = null
    let kleinste = Infinity

    etages.forEach(e => {
      const r = e.getBoundingClientRect()
      const d = Math.abs((r.top + r.bottom) / 2 - midden)
      if (d < kleinste) {
        kleinste = d
        best = e
      }
    })

    zet(best)
  }

  // Hover wint van scroll.
  lijst.addEventListener('mouseleave', () => { hovert = false; kies() })
  etages.forEach(et => {
    et.addEventListener('mouseenter', () => { hovert = true; zet(et) })
  })

  window.addEventListener('scroll', () => {
    if (wacht) return
    wacht = true
    requestAnimationFrame(() => { kies(); wacht = false })
  }, { passive: true })

  window.addEventListener('resize', kies, { passive: true })

  if (document.readyState === 'complete') kies()
  else window.addEventListener('load', kies)
  setTimeout(kies, 80)
}

export default CareerLift
